import { Pipe, PipeTransform } from '@angular/core';

import { DisplayLabels } from '@shared/restaurant/models';

@Pipe({name: 'transformDynamicFields'})
export class TransformDynamicFieldsPipe implements PipeTransform {
  transform(value: string, displayLabels: DisplayLabels): string {
    value = value.replace('{reservationPlural}', capitalize(displayLabels.reservation_plural));
    value = value.replace('{reservationLabel}', capitalize(displayLabels.reservation));

    return value;
  }
}

function capitalize(str: string): string {
  if (!str) {
    return '';
  }

  return str.charAt(0).toUpperCase() + str.slice(1);
}
